import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { TypeaheadService } from '../../../services/typeahead.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-service-object',
  templateUrl: './service-object.component.html',
  styleUrls: ['./service-object.component.css']
})
export class ServiceObjectComponent implements OnInit {
    serviceObjectKeyno;

    public edit?: Edit;

    public selectListTypes: Item[] = [];

    public saving = false;

    public deleting = false;

    public serviceObjectTypeButtons: FormButton[] = [
        { id: 'list', type: 'primary', icon: 'fa fa-solid fa-bars', onClick: () => this.stateService?.go('serviceobjecttypes') }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private typeahead: TypeaheadService) {
        this.serviceObjectKeyno = this.stateService.getStateParams()['serviceobject_keyno'];
    }

    private async loadEdit() {
        if (!!this.serviceObjectKeyno) {
            this.edit = (await this.datatask.Post(1735, { serviceobject_keyno: this.serviceObjectKeyno }))[0];
        }
    }

    private async loadTypes() {
        this.selectListTypes = await this.datatask.Post(1739);
    }

    public searchCustomerNames = () => {
        return this.typeahead.searchCustomer({
            cust_name: this.edit?.cust_name ?? '',
            custtype: 'C',
            lastselect: 'SEARCH'
        });
    }

    public onCustomerNameSelected(item?: Item) {
        if (!!this.edit) {
            this.edit.cust_no = item?.item_id ?? '0';
            this.edit.cust_name = item?.item_name ?? '';
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1736, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(2115, { serviceobject_keyno: this.edit.serviceobject_keyno }))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'picturebanks':
                this.stateService?.go('picturebanks', {
                    argtype: 'serviceobject_keyno',
                    argvalue: this.edit?.serviceobject_keyno
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadEdit();
        this.loadTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    serviceobject_keyno: number;
    serviceobject_name: string;
    vehicle_regno: string;
    imo_no: number;
    serialnos: string;
    cust_name: string;
    cust_no: string | number;
    show_imo_no: string;
    show_vehicle_regno: string;
    picture_url: string;
    delivered_date: string;
    serviceobjecttype_keyno: string;
    show_delete_button: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('serviceObject', {
//        templateUrl: 'views/components/views/serviceObject/serviceObject.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'serviceObjectTypesService', 'serviceObjectService', 'typeaheadService', function ($stateParams, stateService, modalService, translateService, serviceObjectTypesService, serviceObjectService, typeaheadService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let serviceObjectKeyno = $stateParams.serviceobject_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                serviceObjectTypeButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('serviceobjecttypes') }
//                ],
//                custNameButtons: [
//                    { id: 'new', icon: 'fa fa-solid fa-plus', color: 'primary', type: 'primary', onClick: () => stateService.go('customeredit', { cust_no: '0' }) }
//                ],
//                edit: {},
//                selectListTypes: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            translateService.translateBatch(translations).then(function (data) {
//                angular.forEach(translations, function (_, key) {
//                    if (angular.isDefined(data[key])) {
//                        translations[key] = data[key];
//                    }
//                });
//            });

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE CALLS

//            let loadEdit = function () {
//                serviceObjectService.getEdit({ serviceobject_keyno: serviceObjectKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.edit);
//                });
//            };

//            let loadServiceObjectTypes = function () {
//                serviceObjectTypesService.listServiceObjectTypes().then(function (list) {
//                    angular.copy(list, vm.model.selectListTypes);
//                });
//            };

//            // #endregion LOAD PROCEDURE CALLS

//            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            vm.typeaheadSearch = function (value) {
//                return typeaheadService.searchCustomer({
//                    cust_name: value || '',
//                    filtertype: '',
//                    filtervalue: '',
//                    custtype: 'C',
//                    lastselect: 'SEARCH'
//                });
//            };

//            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//            // #region SELECTED VALUE FUNCTION

//            vm.onSelected = function (item) {
//                if (item) {
//                    vm.model.edit.cust_no = item?.item_id ?? '0';
//                    vm.model.edit.cust_name = item?.item_name ?? '';
//                } else {
//                    vm.onClear();
//                }
//            };

//            // #endregion SELECTED VALUE FUNCTION

//            // #region CHANGED VALUE FUNCTION

//            vm.onChanged = function (value, item) {
//                vm.model.edit.cust_name = value;

//                if (value) {
//                    if (item?.item_id) {
//                        vm.model.edit.cust_no = item.item_id;
//                    }
//                } else {
//                    vm.onClear();
//                }
//            };

//            // #endregion CHANGED VALUE FUNCTION

//            // #region CLEAR VALUE FUNCTION

//            vm.onClear = function () {
//                vm.model.edit.cust_no = '0';
//                vm.model.edit.cust_name = '';
//            };

//            // #endregion CLEAR VALUE FUNCTION

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'picturebanks':
//                        go({
//                            argtype: 'serviceobject_keyno',
//                            argvalue: vm.model.edit.serviceobject_keyno
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                serviceObjectService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    serviceObjectService.deleteItem({ serviceobject_keyno: vm.model.edit.serviceobject_keyno }).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back(2);
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//                loadServiceObjectTypes();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
